import { LoginRoute } from "../../presentation/auth";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./auth.provider";

export const PrivateRoute = () => {
  const { user } = useAuth();

  return user === null ? <Navigate to={LoginRoute} replace /> : <Outlet />;
};
